export default __webpack_public_path__ + "2ea5b50b7361e6de561c8a1b335b14fd.svg";